import React from 'react';
import protoaiData from '../data/protoai-data.json';

// protoAI Components
import PageHero from './components-protoai/PageHero';
import ContactSection from './components-protoai/ContactSection';

const ContactPage = () => {
  return (
    <div>
      {/* ページヘッダー */}
      <PageHero
        title="お問い合わせ"
        subtitle="AIで事業を加速させたいとお考えなら、まずはお気軽にご相談ください"
        breadcrumb="お問い合わせ"
      />

      {/* 見積もりバナー */}
      <section className="p-50px-tb" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-8">
              <h3 className="text-white font-weight-bold m-10px-b">開発したいアプリの見積もりを瞬時に取得</h3>
              <p className="text-white m-0" style={{ opacity: 0.9 }}>質問に答えるだけで、概算費用と開発期間がすぐにわかります</p>
            </div>
            <div className="col-lg-4 text-lg-right text-center m-15px-t lg-m-0-t">
              <a href="/#/estimate" className="btn btn-light btn-lg font-weight-bold" style={{ padding: '15px 40px', borderRadius: '50px' }}>
                見積もりを開始 <i className="icofont-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* お問い合わせ詳細 - 新しい法人向けフォーム */}
      <ContactSection data={protoaiData.contact} />
    </div>
  );
};

export default ContactPage;